import { createContext, RefObject, useContext } from 'react'

export const ScrollAreaContext = createContext<{
	scrollContainerRef: RefObject<HTMLDivElement | null>
}>({
	scrollContainerRef: { current: null },
})

export const ScrollAreaProvider = ScrollAreaContext.Provider
export function useScrollAreaContext() {
	return useContext(ScrollAreaContext)
}
